<template>
    <div >
     
      <div >
          
    
    
 <div style="height: 100%;" class=" mb-5 background_color h-100" >
               
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
<div class="container-fluid h-100">
 


    <b-modal  :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
       hide-footer
     bottom>
    <template    #modal-title>
     
      <h1 >Payment</h1>

      
  
    </template>
    
   <div>
    <table class="table font-pos table-info table-striped ">
          
          <tbody>
            <tr>
              <td>Cash</td>
              <td style="text-align: right; width: 150px;"><input  v-model="cashvalue" style="text-align: right;"  class="form-control  bdr-rad" @input="balnceValue()" > </td>
            </tr>
            <tr>
              <td>Total to Pay</td>
              <td style="text-align: right;">{{ final_total }} </td>
            </tr>
            <tr>
              <td>Balance</td>
              <td style="text-align: right;">{{ balnce }} </td>
            </tr>
           
               
          </tbody>
          </table>

          <div class="d-grid gap-2">
  
            <button  @click="printReceipt()"  type="submit" class=" btn btn-lg btn-outline-primary font-pos   bdr-rad">Print Receipt</button>
          </div>

   </div>

       
    
    

  

  
  </b-modal>



 

   



<br>
<div class="row">
  <!-- Left side: Product Table (existing) -->
  <div class="col-md-7 d-flex flex-column"  >

     <div class="card bdr-rad2  shadow h-100 overflow-hidden">
  <div  class="card-body custom_bdr_rds">
    
    <div style="border-bottom: 0px; padding-top: 0px; " class="">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
      {{ username }}  <span style="margin-left: 10px;"> {{ currentDateTime }}</span> 
      
    </div>
    </div>
<div class="card custom_bdr_rds">
        <div class="card-body custom_bdr_rds">

         <div class="row align-items-center mb-3">
  <!-- Back Button (with arrow) -->
  <div class="col-auto">
    <button class="btn btn-outline-primary bdr-rad" @click="goBack">
      <i class="fa fa-arrow-left"></i> Exit
    </button>
  </div>

  <!-- Title centered horizontally -->
  <div class="col text-center">
    <h1 class="m-0" style="color: #007bff;">Online POS</h1>
  </div>
</div>

         
    <div class="invoice-container d-flex flex-column" style="max-height: 70vh;" >
    <div class="table-wrapper flex-grow-1 overflow-auto" style="min-height: 40vh;">
      <table    class="table table  table-hover font-pos">
        <thead class="background_color2" >
          
          <tr   >
                <th style="border-top-left-radius: 12px;border-bottom-left-radius: 12px;"></th>
                <th  >   
                  <div class="form-group custom-form required">
                    <label class="custom-label3"> Product Code</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label3"> Selling Price</label>
                  </div>
                </th>
               
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label3"> Qty</label>
                  </div>
                </th>
               
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label3"> Line Amount</label>
                  </div>
                </th>
                
                
              
                <th style="border-top-right-radius: 12px;border-bottom-right-radius: 12px;"></th>  
            </tr>
          </thead>
          <tbody>
            <tr>
                <td>  <b-icon @click="remove" v-show="this.count>0" class="ms-3 me-3 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon> </td>
              <td style="width: 40%;">
                <v-select  v-model="detail[0].idproduct" label="label"  :options="mproducts" @input="loadPrice(0)"></v-select>
              </td>
              <td><input v-model="detail[0].price"   class="form-control text_right bdr-rad" disabled>
                <!-- <input type="hidden" v-model="detail[0].ave_cost"   class="form-control" > -->
              </td>
             
              <td><input  v-model="detail[0].qty"  class="form-control text_right bdr-rad" @input="calculateqty(0); currentProductIndex = 1" ></td>
              
              <td><input  v-model="detail[0].line_amount"  class="form-control text_right bdr-rad" disabled></td>
             
              <td class="custom-icon">  <b-icon @click="add(0)" class=" mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
              
            </tr>
            <tr v-for="key in count" :key="key" >
                <td>
                    <b-icon @click="remove" class="ms-3 me-3 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon>
                </td>
              <td> <v-select v-model="detail[key].idproduct" label="label"  :options="mproducts" @input="loadPrice(key)"></v-select></td>
              <td><input  v-model="detail[key].price"  class="form-control text_right bdr-rad" disabled>
                <!-- <input type="hidden" v-model="detail[key].ave_cost"   class="form-control " > -->
              </td>
             
              <td><input  v-model="detail[key].qty"  class="form-control text_right bdr-rad" @input="calculateqty(key); currentProductIndex = key+1" ></td>
             
              <td><input  v-model="detail[key].line_amount"  class="form-control text_right bdr-rad" disabled></td>
             


              <td class="custom-icon"> 
              
                 <b-icon @click="add(key)" class=" mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon>
                 </td>
              
            </tr >
                 </tbody>
    </table>
  </div>

            
    <div style="width: 100%;" class="summary-footer mt-2">
    <table  class="table  table-hover font-pos">
      <tbody>
            <tr >
                <td> </td>
              <td></td>
              <td>Sub Total</td>
           
              
              <td></td>
            
              <td class="text_right" >{{ subtotal }}</td>
          
              <td></td>
              
            </tr>
            <tr >
                <td> </td>
              <td></td>
              <td>VAT (15%)</td>
              <td></td>
              
             
            
              <td  class="text_right">{{vat}}</td>
             
              <td></td>
              
            </tr>
            <tr >
                <td> </td>
              <td></td>
              <td>Total to Pay</td>
          
              
              <td></td>
            
              <td class="text_right">{{ final_total }}</td>
              <td></td>
           
              
            </tr>

     
          
            
          </tbody>


        </table>
       
    </div>
    </div>
    </div>
    </div>
     <div class="d-grid gap-2">
  
  <button  @click="SaveQuotation()"  type="" class=" btn btn-lg btn-outline-primary font-pos   bdr-rad">PAY</button>
</div>


  </div>
 </div>
</div>
  <!-- Right side: Shortcut Buttons -->
  <div class="col-md-5">
  <div class="card bdr-rad2  shadow ">
  <div  class="card-body custom_bdr_rds">
      <!-- Top Shortcut -->
     <!-- Top Shortcut Buttons - 3 buttons per row -->
<div class="mb-4">
  <div class="row" v-for="(row, rowIndex) in productShortcuts" :key="'row-' + rowIndex">
      <div class="col-4" v-for="(product, i) in row" :key="'btn-' + i + '-' + rowIndex">
        <button
          class="btn btn-outline-primary w-100 mb-2 bdr-rad"
          @click="loadProductShortcut(product.id)"
          style="height: 70px;"
        >
          {{ product.label }}
        </button>
      </div>
    </div>
</div>
  </div>
</div>


      <!-- Number Pad for Qty -->
        <div class="card bdr-rad2  shadow ">
  <div  class="card-body custom_bdr_rds">
       <div class="container">
      <div class="row">
        <div
          class="col-4 mb-2"
          v-for="n in [1, 2, 3, 4, 5, 6, 7, 8, 9]"
          :key="'num-' + n"
        >
          <button class="btn btn-outline-primary w-100 bdr-rad" @click="appendQty(n)" style="height: 70px;">
            {{ n }}
          </button>
        </div>
        <div class="col-4 mb-2">
          <button class="btn btn-outline-primary w-100 bdr-rad" @click="appendQty(0)"  style="height: 70px;">
            0
          </button>
        </div>
        <div class="col-4 mb-2">
          <button class="btn btn-outline-danger w-100 bdr-rad" @click="clearQty"  style="height: 70px;">
            Cancel
          </button>
        </div>
        <div class="col-4 mb-2">
          <button class="btn btn-outline-success w-100 bdr-rad" style="height: 70px;">
          Cash
          </button>
        </div>
      </div>
    </div>
    </div>
    </div>
  </div>
</div>







   


               
                <br><br><br><br>
              </div> 
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
   
  </div>
    
    </template>
 
  
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
          setInterval(() => {
      this.currentDateTime = this.getCurrentDateTime();
    }, 1000);
  
    this.loadCustomer();
      },
        data() {
          return {
            currentDateTime: this.getCurrentDateTime(),
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            username:authService.isUsername(),
            count: 0,
            currentProductIndex: 0,
tempQty: '',
productShortcuts: [
  [ { id: 1, label: 'WASHER' }, { id: 3, label: 'RING' }, { id: 6, label: 'NUT' } ],
  [ { id: 11, label: 'COVER' }, { id: 18, label: 'PIN' }, { id: 21, label: 'HUB' } ],
  [ { id: 22, label: 'HANDLE' }, { id: 30, label: 'BELLOW' }, { id: 32, label: 'SPRING' } ],
  [ { id: 42, label: 'SPACER' }, { id: 43, label: 'PLATE' }, { id: 87, label: 'PLUNGER' } ],
  [ { id: 87, label: 'PLUNGER' }, { id: 94, label: 'CROSS' }, { id: 102, label: 'SHIM' } ],
  [ { id: 243, label: 'FLANGE' }, { id: 212, label: 'JOINT' }, { id: 179, label: 'BUSH' } ],
],
        total:0,
        selectedOption: null, // Store the selected option
        subtotal:"0.00",
        gpmrg_total:"0.00",
        gpMrgPre_total:"0.00",
        final_total:"0.00",
        vat:"0.00",
        qty:0,
        cashvalue:'',
        balnce:'',
        inv_id:'',
        receipt_id:'',
        mproducts:[],
       
     
      errors: {},
     
      squatation:{},
        customer:{},
        quotation:{
          'validity_period':{
            label: 'Select Validity Period', value: ''
          },
          'payment_method':{
            label: 'Cash', value: 'Cash'
          },
          'remarks':'',
          'special_discount':0.00,
        },
        sales:{},
        Brands:[],
        detail:[
      {},  
      ],
     
      infoModal1: {
          id: 'info-modal1',
          title: '',
          content: [],
        },

     
       
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },
    

        methods : {

            goBack() {
    this.$router.go(-1); // Or use this.$router.push('/previous-route') if needed
  },

   async loadProductShortcut(productId) {
    console.log(this.currentProductIndex);
  const product = this.mproducts.find(p => p.value == productId);
  if (product) {
    this.$set(this.detail[this.count], 'idproduct', product);
    await this.loadPrice(this.count);
  } else {
    alert('Product not found!');
  }
},

appendQty(num) {
  this.tempQty += num.toString();
  const index = this.count;
  this.$set(this.detail[index], 'qty', parseInt(this.tempQty));
  this.calculateqty(index);
},

// Clear quantity input
clearQty() {
  this.tempQty = '';
  const index = this.count;
  this.$set(this.detail[index], 'qty', '');
  this.calculateqty(index);
},

          getCurrentDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

   





  

    balnceValue(){
      this.balnce = (this.cashvalue - this.final_total).toFixed(2);
    },


    
        async SaveQuotation() {
     
      console.log(this.detail);

      
        try {
         const { data} = await  axios.post('/sinvoice/create',{userid:this.userid,detail:this.detail,currentDateTime:this.currentDateTime,vat:this.vat,final_total:this.final_total},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.inv_id = data.inv_id;
          this.infoModal1.content = this.inv_id;
          this.$root.$emit('bv::show::modal', this.infoModal1.id);
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     
     },

    
    async loadCustomer() {
       
     
       try {
         const { data} = await  axios.get('/mcustomer/customerload1',{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          
       
          
          this.mproducts = data.mproducts;
         
       } catch (error) {
         console.log(error.response);
       }
     },

    

 

     async loadPrice(id) {
       
     console.log(id);
       try {
         const { data} = await  axios.post('/mproduct/loadprice1',{idproduct:this.detail[id].idproduct},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.$set(this.detail[id], 'price', data.selling_price);
       
          // this.$set(this.detail[id], 'ave_cost', data.ave_cost);
          
          
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async calculateqty(id) {
      
     
    
    
      const line_amount = (this.detail[id].price * this.detail[id].qty).toFixed(2);
      this.$set(this.detail[id], 'line_amount', line_amount);

  

        let line_amount_tot = 0;

          for (let i = 0; i <= this.count; i++) {
        line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty;



          }

        this.subtotal = line_amount_tot.toFixed(2);
        

        
        const vat1 = this.subtotal - this.subtotal*100/115;

        this.vat = vat1.toFixed(2);


        this.final_total = this.subtotal;
  
     },

    


    

   

    



   

     validate(){
      this.errors = {};
      if(this.squatation.idcustomer == null){
        this.$set(this.errors, 'idCustomerError', "Customer field is required");
      }
      if(this.squatation.customer_contact == null){
        this.$set(this.errors, 'customerContactError', "Customer Contact field is required");
      }
      if(this.sales == null){
        this.$set(this.errors, 'salespeoplesError', "Sales Person field is required");
      }
      if(this.quotation.id_brand == null){
        this.$set(this.errors, 'idbrandError', "Brand field is required");
      }
     },

    


     async printReceipt() {
     
       try {
        const { data} = await  axios.post('/spaymentreceipts/create1',{userid:this.userid,cashvalue:this.cashvalue,currentDateTime:this.currentDateTime,final_total:this.final_total,balnce:this.balnce,inv_id:this.inv_id},{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data.receipt_id);
       if(data.status==200){
        this.receipt_id = data.receipt_id;

        window.open('/quotation/printpos?id=' + this.receipt_id, '_blank');
        window.location.reload();
       
        
       }
         
          
        
      } catch (error) {
        console.log(error.response);
      }
     
      
     

     
    },
       

        add: function(id){
          this.tempQty = '';
          if(this.detail[id].qty>0){
            this.count++;
            this.detail.push({
             
            },)
          }
           
           
        },

  remove: function () {
  this.tempQty = '';
            this.count--;
            this.detail.splice({
              
            },1)
            
        },

    },
    
    }
    
    </script>

    <style scoped>




.table>:not(:last-child)>:last-child>* {
    border-bottom-color: white !important;
}

    .button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
html, body, #app {
  height: 100%;
  margin: 0;
}




      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    